import STATISTIC_TYPES from "../CustomDataGenerationPage/STATISTIC_TYPES";

/**
 * Formats a number with thousands separators
 * @param {number} num - Number to format
 * @returns {string} Formatted number string with commas
 */
const formatNumber = (num, statisticType) => {
    let formattedNum = typeof num === "number" ? num : +num;
    if (statisticType === STATISTIC_TYPES.百分比.value) {
        return `${(formattedNum * 100).toFixed(1)}%`;
    }

    if (statisticType === STATISTIC_TYPES.平均數.value) {
         return `${formattedNum.toFixed(1)}`;
    }

     if (formattedNum === 0) {
        return "0";
    }

    if (formattedNum > 1000) {
        // return 1,000
        return Math.round(formattedNum).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return Math.round(formattedNum);
};

export default formatNumber;
